import axios from '../http.js'

//我的课程列表
function getList(data) {
  return axios.baseAxios({
    url: '/backstage/courseStudent/studentCoursePage',
    method: 'post',
    data: data
  })
}
//报名课程
function signUpCourse(data) {
  return axios.baseAxios({
    url: '/backstage/courseStudent/signUpCourse',
    method: 'post',
    params: data
  })
}
//虚仿课程学习
function labAccessCourseLearning(data) {
  return axios.baseAxios({
    url: '/backstage/courseStudent/labAccessCourseLearning',
    method: 'post',
    params: data
  })
}
//获取课程目录信息（用于定时更新课程学习情况）
function labAccessCourseChapters(data) {
  return axios.baseAxios({
    url: '/backstage/courseStudent/labAccessCourseChapters',
    method: 'post',
    params: data
  })
}
//获取学生学习情况统计信息
function courseStatistics() {
  return axios.baseAxios({
    url: '/backstage/courseStudent/courseStatistics',
    method: 'get'
  })
}
//============视频相关
//获取课程设置
function getCourseSettings(id) {
  return axios.baseAxios({
    url: '/backstage/courseStudent/course-settings/' + id,
    method: 'get'
  })
}
// 获取用户信息
function getUserInfo() {
  return axios.baseAxios({
    url: '/backstage/courseStudent/records/as-situation',
    method: 'get'
  })
}
// 获取普通课程的目录信息
function normalCourseLearning(data) {
  return axios.baseAxios({
    url: '/backstage/courseStudent/normalCourseLearning',
    method: 'post',
    params: data
  })
}

//同步普通课课程章节学习情况
function normalStudentCourseChapters(data) {
  return axios.baseAxios({
    url: '/backstage/courseStudent/normalStudentCourseChapters',
    method: 'post',
    data: data
  })
}
//普通课准入课程学习章节信息查询
function labAccessNormalCourseChapters (data) {
  return axios.formDataAxios({
    url: '/backstage/courseStudent/labAccessNormalCourseChapters',
    method: 'post',
    data: data
  })
}

export default {
  getList,
  signUpCourse,
  labAccessCourseLearning,
  labAccessCourseChapters,
  courseStatistics,
  getCourseSettings,
  getUserInfo,
  normalCourseLearning,
  normalStudentCourseChapters,
  labAccessNormalCourseChapters
}


// WEBPACK FOOTER //
// ./src/api/modules/myCourse.js